import { Badge, Group } from '@mantine/core';

import { MealPeriodEnum } from '@/api';

import { mealPeriodLabel } from '../helpers';

type MealPeriodBadgesProps = {
  mealPeriods: MealPeriodEnum[];
};

export const MealPeriodBadges: React.FC<MealPeriodBadgesProps> = ({ mealPeriods }) => {
  if (mealPeriods.length === 0) return null;

  return (
    <Group gap={6}>
      {mealPeriods.map((mealPeriod) => (
        <Badge key={mealPeriod} variant="light" radius="sm" size="sm" color="gray">
          {mealPeriodLabel(mealPeriod)}
        </Badge>
      ))}
    </Group>
  );
};

